import request from '@/shared/api/request';

import type { BaremetalServer } from '../types';

export const createBaremetalServer = (data: {
  name: string;
  size: string;
  region: string;
  kickstart: string;
  project_uuid?: string;
  tags: string[];
}): Promise<{ baremetal: BaremetalServer }> =>
  request({
    url: '/baremetals/',
    method: 'POST',
    data,
  });
